var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home",style:({minHeight: _vm.bodyHeight + 'px'})},[_c('router-view'),_c('div',{staticClass:"copyright"},[_vm._v("版权所有 © 2020 CHINA LAB 备案序号：京ICP备06050757号-15")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }